import styled from "styled-components";


export const Container = styled.div`

    display: flex;
    align-items: center;
    justify-content:center;
    flex-direction: column;
    width:100%;
    height:100vh;


`;

export const Img = styled.img`
    cursor: pointer;
    &:hover {
        opacity: 0.9;
    }
`;

